import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import { CreateButton } from 'react-admin';
import { SOCIAL_TYPES, USER_TYPES } from '../constants';
import {
  List,
  Edit,
  Create,
  Show,
  TabbedShowLayout,
  Tab,
  Datagrid,
  TextField,
  EmailField,
  ImageField,
  SimpleForm,
  TextInput,
  EditButton,
  ShowButton,
  FileField,
  FileInput,
  Filter,
  SelectInput,
} from 'react-admin';
import GeneralInfoTab from './userTabs/GeneralInfoTab';
import PaymentsTab from './userTabs/PaymentsTab';
import DevicesTab from './userTabs/DevicesTab';


const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="firstName" source="firstName" alwaysOn />
    <TextInput label="lastName" source="lastName" alwaysOn />
    <TextInput label="Email" source="email" alwaysOn />
    <TextInput label="Phone Number" source="phoneNumber" alwaysOn />
  </Filter>
);

const UserAction = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    basePath,
  } = props

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const UserList = props => (
  <List {...props} filters={<TextFilter/>} actions={<UserAction props={props} />}>
    <Datagrid rowClick="show">
      <TextField source="id" /> 
      <TextField source="firstName" />
      <TextField source="lastName" />
      <EmailField source="email" />
      <TextField source="phoneNumber" />
      <TextField source="social" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const UserEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="phoneNumber" />
      <TextInput source="email" />
      <ImageField source="picture" title="Зураг" />
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
      <SelectInput label="Нэвтэрсэн Сошиал хаяг" source="social" choices={SOCIAL_TYPES} />
      <SelectInput label="Төрөл" source="type" choices={USER_TYPES} />
    </SimpleForm>
  </Edit>
);

export const UserCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="phoneNumber" />
      <TextInput source="email" />
      <FileInput source="file" label="Зураг" accept="image/*">
        <FileField source="image" title="image" />
      </FileInput>
      <TextInput source="social" defaultValue="MANUAL" disabled={true}/>
    </SimpleForm>
  </Create>
);

export const UserShow = props => {
  return (
    <Show {...props}>
      <TabbedShowLayout>
        <Tab label="Ерөнхий мэдээлэл">
          <GeneralInfoTab {...props} />
        </Tab>
        <Tab label="Төлбөрийн мэдээлэл" path="payments">
          <PaymentsTab {...props} />
        </Tab>
        <Tab label="Төхөөрөмжүүд" path="devices">
          <DevicesTab {...props} />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};